import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/api-reference.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "lifecycle-api-reference"
    }}>{`Lifecycle API reference`}</h1>
    <h2 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`extensionVersion()`}</inlineCode>{` API returns the version of the Lifecycle extension that is registered with the Mobile Core extension.`}</p>
    <p>{`To get the version of the Lifecycle extension, use the following code sample:`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=extension-version" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=extension-version" mdxType="Tabs" />
    {/*- React Native
     <Tabs query="platform=react-native&api=extension-version"/>
     Flutter
     <Tabs query="platform=flutter&api=extension-version"/> -*/}
    <h2 {...{
      "id": "lifecyclestart"
    }}>{`lifecycleStart`}</h2>
    <p>{`Starts the collection of lifecycle data.`}</p>
    <p><strong parentName="p">{`For Analytics use case:`}</strong>{` Use this API to start a new lifecycle session or resume a previously paused lifecycle session. If a previously paused session timed out, then a new session is created. If a current session is running, then calling this method does nothing.`}</p>
    <p><strong parentName="p">{`For Platform use case:`}</strong>{` Use this API to dispatch a `}<a parentName="p" {...{
        "href": "./event-reference.md#lifecycle-application-foreground"
      }}>{`Lifecycle Application Foreground`}</a>{` event when the application is launched.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=lifecycle-start" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=lifecycle-start" mdxType="Tabs" />
    {/*- React Native
     <Tabs query="platform=react-native&api=lifecycle-start"/> -*/}
    <h2 {...{
      "id": "lifecyclepause"
    }}>{`lifecyclePause`}</h2>
    <p>{`Pauses the collection of lifecycle data.`}</p>
    <p><strong parentName="p">{`For Analytics use case:`}</strong>{` Use this API to pause the collection of lifecycle data.`}</p>
    <p><strong parentName="p">{`For Platform use case:`}</strong>{` Use this API to dispatch a `}<a parentName="p" {...{
        "href": "./event-reference.md#lifecycle-application-background"
      }}>{`Lifecycle Application Background`}</a>{` event when the application closes.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=lifecycle-pause" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=lifecycle-pause" mdxType="Tabs" />
    {/*- React Native
     <Tabs query="platform=react-native&api=lifecycle-pause"/> -*/}
    <h2 {...{
      "id": "registerextension"
    }}>{`registerExtension`}</h2>
    <InlineAlert variant="warning" slots="header, text1" mdxType="InlineAlert" />
    <p>{`This API has been deprecated starting in v2.0.0 and removed in v3.0.0 of the Android mobile extension.`}</p>
    <p>{`Use `}<a parentName="p" {...{
        "href": "../api-reference.md#registerextensions"
      }}><inlineCode parentName="a">{`MobileCore.registerExtensions()`}</inlineCode></a>{` API instead.`}</p>
    <p>{`Registers the Lifecycle extension with the Mobile Core.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="1" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=register-extension" mdxType="Tabs" />
    {/*- React Native
     <Tabs query="platform=react-native&api=register-extension"/> -*/}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      